import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b" style={{
    borderColor: '#C5DDD1'
  }} data-id="element-2">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 text-left" aria-expanded={isOpen} data-id="element-3">
        <span className="text-base md:text-lg font-medium pr-4" style={{
        color: '#1A1A1A'
      }} data-id="element-4">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-5">
          <ChevronDownIcon className="w-5 h-5 flex-shrink-0" style={{
          color: '#C9A96E'
        }} data-id="element-6" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-7">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-8">
            <p className="pb-5 text-base" style={{
          color: '#4A4A4A'
        }} data-id="element-9">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Pasaré hambre?',
    answer: 'No, el plan incluye proteínas y grasas saludables que te mantienen saciada.'
  }, {
    question: '¿Necesito suplementos caros?',
    answer: 'Ninguno. Todo lo encuentras en la plaza de mercado o el súper.'
  }, {
    question: '¿Es seguro si tengo colon irritable?',
    answer: 'Sí, el protocolo elimina los gatillos inflamatorios más comunes.'
  }, {
    question: '¿Puedo tomar café?',
    answer: 'Sí, te enseñamos cómo tomarlo para que no te inflame.'
  }, {
    question: '¿El pago es seguro?',
    answer: 'Totalmente. Usamos plataformas de pago encriptadas de nivel bancario.'
  }, {
    question: '¿Recibo el material físico?',
    answer: 'Es un producto digital (eBook) que recibes al instante en tu correo.'
  }];
  return <section className="w-full py-16 md:py-24" style={{
    backgroundColor: '#F0F7F4'
  }} data-id="element-10">
      <div className="max-w-3xl mx-auto px-4" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-12" style={{
          color: '#1A1A1A'
        }} data-id="element-13">
            Preguntas Frecuentes
          </h2>

          <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm" data-id="element-14">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-15" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}